var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsUpSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 6.04167C13.6785 6.04167 13.9583 6.32149 13.9583 6.66667V13.3333C13.9583 13.6785 13.6785 13.9583 13.3333 13.9583C12.9882 13.9583 12.7083 13.6785 12.7083 13.3333V6.66667C12.7083 6.32149 12.9882 6.04167 13.3333 6.04167Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.54167C10.3452 8.54167 10.625 8.82149 10.625 9.16667V13.3333C10.625 13.6785 10.3452 13.9583 10 13.9583C9.65482 13.9583 9.375 13.6785 9.375 13.3333V9.16667C9.375 8.82149 9.65482 8.54167 10 8.54167Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 10.2083C7.01184 10.2083 7.29167 10.4882 7.29167 10.8333V13.3333C7.29167 13.6785 7.01184 13.9583 6.66667 13.9583C6.32149 13.9583 6.04167 13.6785 6.04167 13.3333V10.8333C6.04167 10.4882 6.32149 10.2083 6.66667 10.2083Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 3.125V16.875H16.875V3.125H3.125ZM1.875 3C1.875 2.37868 2.37868 1.875 3 1.875H17C17.6213 1.875 18.125 2.37868 18.125 3V17C18.125 17.6213 17.6213 18.125 17 18.125H3C2.37868 18.125 1.875 17.6213 1.875 17V3Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsUpSquare);
export default __webpack_public_path__ + "static/media/stats-up-square.8895cfb0a8ffa289d6645fc3ca6e8f2c.svg";
export { ForwardRef as ReactComponent };